import * as React from 'react';
import Flex from 'ui/Flex/Flex';
import { Skeleton } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyUnreadNotificationLoading = styled(Flex, {
    name: 'StyUnreadNotificationLoading',
})(() => ({}));

const UnreadNotificationLoading = (): JSX.Element => (
    <StyUnreadNotificationLoading align="center" sx={{ gap: 2 }}>
        <Skeleton variant="circular" width={32} height={32} />
        <Flex direction="column" align="start">
            <Skeleton variant="text" sx={{ fontSize: '2rem' }} width={200} />
            <Skeleton variant="text" sx={{ fontSize: '2rem' }} width={140} />
        </Flex>
    </StyUnreadNotificationLoading>
);

export default UnreadNotificationLoading;
